import React, { useState, useEffect, useRef, useContext } from "react";
import {
  DatePicker,
  Row,
  Divider,
  Col,
  Card,
  Button,
  Modal,
  Radio,
  notification,
} from "antd";
import moment from "moment";
import "../../../assets/css/tms-darshanam/tms-pos-darshanam.scss";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import { RightOutlined } from "@ant-design/icons";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import TmsPrintTicket from "../../../components/tms-print-ticket/tms-print-ticket";
import TmsStringUtils from "../../../utils/tms-string-utils/tms-string-utils";
import { BaseContext } from "../../../contexts/BaseContext";
import Webcam from "react-webcam";
import TmsCommonService from "../../../services/tms-common.service";
import TmsShivaDeekshaService from "../../../services/shiva-deeksha.service";

const PosShivaDeeksha = ({ router }) => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const [bookingDate, setBookingDate] = useState(moment());
  const [shivaDeekshaList, setshivaDeekshaList] = useState([]);
  const [persons, setPersons] = useState(1);
  const [shivaDeekshaId, setshivaDeekshaId] = useState();
  const [externalPrint, setExternalPrint] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [array, setArray] = useState([]);
  const [updateFlag, setUpdateFlag] = useState();
  const [ticketType, setTicketType] = useState();
  const webcamRef = useRef(null);
  const { userDetails } = useContext(BaseContext);

  const { setCouponCode, setVerifiedCouponData, setUsedBy } =
    useContext(BaseContext);

  const ref = useRef(null);

  const shivadeekshaData = (data, imgSrc) => {
    let schemaBody = [];
    const generalBody = [
      [
        "Date",
        moment(data?.booking.bookingDate).format("DD-MM-YYYY"),
        { margin: "0" },
      ],
      ["Gender", data?.booking?.gender, { margin: "0" }],
      [
        "footer",
        data?.ticket,
        {},
        data?.annadanamName,
        `<p style="margin:0"><p style="margin:0">${moment(
          data?.booking?.bookingDate
        ).format(
          "DD-MM-YYYY"
        )}</p><p style="font-weight:bold;font-size:22px;margin:0">Rs. ${
          data?.booking?.price
        }.00</p> `,
        !data?.productDetails?.productMetadata?.termsAndConditions ||
        data?.productDetails?.productMetadata?.termsAndConditions[0] === ""
          ? null
          : data?.productDetails?.productMetadata?.termsAndConditions
              ?.map((item, i) => {
                return `<p style="margin:0" key=${i}>${item}</p>`;
              })
              .join(" "),
        data?.createdAt,
        imgSrc,
      ],
    ];
    const miniTicketBody = [
      [
        "Total Amount",
        `Rs. ${data?.booking.price}.00 `,
        { margin: "0", fontWeight: "800" },
      ],
      ["footer", data?.ticket, {}, {}, {}, null, data?.createdAt],
    ];
    const basicBody = [
      [
        "header",
        data?.counterCategoryTransaction_id?.split("-")?.pop(),
        {},
        data?.dailyCategoryTransaction_id?.split("-")?.pop(),
        data?.ticket,
      ],
      [
        "Ticket Id",
        data?.productDetails?.productMetadata?.ticketType === "mini_ticket"
          ? data?.ticket?.split("-")?.pop()
          : data?.ticket,
        { margin: "0" },
      ],
      [
        "Bhavani Deeksha",
        shivaDeekshaList.find((item) => item.id === shivaDeekshaId)?.name,
        { margin: "0", fontWeight: "700" },
      ],
    ];
    miniTicketBody;
    if (data?.productDetails?.productMetadata?.ticketType === "mini_ticket") {
      schemaBody = [...schemaBody, ...basicBody, ...miniTicketBody];
    } else {
      schemaBody = [...schemaBody, ...basicBody, ...generalBody];
    }
    setArray([...schemaBody]);
  };

  const fetchAnnadanam = async () => {
    document.getElementById("searchable")?.focus();

    if (persons) {
      setButtonLoading(true);
      try {
        setshivaDeekshaList([]);
        // let id = [];
        // let dragList = [];
        let res = await TmsShivaDeekshaService.getShivaDeeksha(1, 100);
        setshivaDeekshaList(res.items);
        setshivaDeekshaId(res.items?.[0]?.id);
      } catch (error) {
        catchErrorFunction(
          error,
          "Token Expired, redirecting to login page in 5 seconds",
          router
        );
      }
      setButtonLoading(false);
    }
  };

  const shivaDeekshaBooking = async (type) => {
    const imageSrc = await webcamRef?.current?.getScreenshot();

    // Convert the base64 image data to a binary Blob
    const binaryData = atob(imageSrc.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: "image/jpeg" });

    let formData = new FormData();
    formData.append("file", blob);

    const url = await TmsCommonService.uploadTempFile(
      formData,
      "person",
      userDetails.user.id
    );
    if (buttonLoading) {
      return;
    }
    setButtonLoading(true);
    if (persons === "") {
      notification.info({
        message: "No of Persons cannot be empty",
      });
      setButtonLoading(false);
      return;
    }
    if (shivaDeekshaId === "" || !shivaDeekshaId) {
      notification.info({
        message: "Please select a Bhavani Deeksha",
      });
      setButtonLoading(false);
      return;
    }
    if (imageSrc === null || !imageSrc) {
      notification.info({
        message: "Please capture a photo",
      });
      setButtonLoading(false);
      return;
    }

    try {
      const data = await TmsShivaDeekshaService.shivaDeekshaBooking(
        shivaDeekshaId,
        type,
        url.path
      );
      shivadeekshaData(data, imageSrc);
      setIsModalVisible(true);
      setExternalPrint(true);
      setPersons("");
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    setCouponCode("");
    setVerifiedCouponData(null);
    setUsedBy("direct");
    fetchAnnadanam();
  }, [bookingDate, persons, updateFlag]);
  // Add keyboard event handler

  useEffect(() => {
    const handleKeyPress = (event) => {
      // Only process if not loading and a slot is selected
      if (!buttonLoading && shivaDeekshaId) {
        if (event.key.toLowerCase() === "m") {
          shivaDeekshaBooking("male");
        } else if (event.key.toLowerCase() === "f") {
          shivaDeekshaBooking("female");
        }
      }
    };

    // Add event listener
    window.addEventListener("keypress", handleKeyPress);

    // Cleanup
    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [buttonLoading, shivaDeekshaId]); // Dependencies array includes variables used in the handler

  // const capture = useCallback(async () => {
  //   setImgSrc(imageSrc);
  // }, [webcamRef]);

  const selectSlot = (productId) => {
    if (productId !== shivaDeekshaId) {
      setCouponCode(null);
      setVerifiedCouponData(null);
    }
    setshivaDeekshaId(productId);
    // setTicketPrice(ticketPrice);
    // setPrice(ticketPrice * persons);
    ref?.current?.focus();
    ref?.current?.focus();
  };

  return (
    <div className="darshanamBody">
      <Card className="darshanamBodyCard">
        {" "}
        <Row justify="center" className="darshanamTitle">
          Bhavani Deeksha
        </Row>
        <Divider />
        <Row gutter={(20, 20)} style={{ justifyContent: "flex-start" }}>
          <Col style={{ width: "30%" }}>
            <Row className="darshanamBookingDate">Booking Date</Row>
            <Row>
              <DatePicker
                disabled={true}
                size="medium"
                allowClear
                defaultPickerValue={moment()}
                format="DD-MM-YYYY"
                value={bookingDate}
                onChange={(e) => {
                  setBookingDate(e);
                  ref?.current?.focus();
                }}
                disabledDate={(d) =>
                  !d || d.isBefore(TmsStringUtils.addDays(new Date(), -1))
                }
                style={{ width: "100%" }}
              />
            </Row>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col xs={24} sm={24} md={12} lg={16} xl={16} xsl={16}>
            {shivaDeekshaList?.length !== 0 && persons ? (
              <div style={{ marginBottom: "20px" }}>
                <Row>
                  <h1 className="resultsTitle">Bhavani Deeksha</h1>
                </Row>
                <Row gutter={[20, 20]} className="resultsRow">
                  {shivaDeekshaList
                    // ?.filter((item) => ids?.includes?.(item?.id))
                    ?.map((item, index) => {
                      return (
                        <Col
                          key={index + item.id}
                          style={{
                            float: "left",
                          }}
                          xs={24}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          xsl={12}
                        >
                          <Card
                            className="darshanamCard"
                            title={
                              <Row>
                                <Col
                                  style={{ textAlign: "left", width: "80%" }}
                                >
                                  Name: {item?.name}
                                </Col>

                                <Col
                                  style={{ textAlign: "right", width: "20%" }}
                                >
                                  <Radio
                                    defaultChecked={false}
                                    value={item?.id}
                                    checked={
                                      item?.id === shivaDeekshaId ? true : false
                                    }
                                    id={item?.id}
                                    onClick={() => {
                                      selectSlot(item?.id);
                                    }}
                                  />
                                </Col>
                              </Row>
                            }
                            hoverable
                            onClick={() => selectSlot(item?.id)}
                            style={{}}
                          ></Card>
                        </Col>
                      );
                    })}
                </Row>
                <br />
                <Row style={{ display: "flex", gap: "10px" }}>
                  <Button
                    ref={ref}
                    type="primary"
                    onClick={() => {
                      buttonLoading === false && shivaDeekshaBooking("male");
                    }}
                    loading={buttonLoading}
                  >
                    Male <RightOutlined />
                  </Button>
                  <Button
                    ref={ref}
                    type="primary"
                    onClick={() => {
                      buttonLoading === false && shivaDeekshaBooking("female");
                    }}
                    loading={buttonLoading}
                  >
                    Female <RightOutlined />
                  </Button>
                </Row>
              </div>
            ) : (
              <>
                <div style={{ position: "relative", textAlign: "left" }}>
                  Fetching deekshas...Please wait{" "}
                </div>
              </>
            )}
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={8} xsl={8}>
            <Divider type="vertical" />
            <>
              <div
                className="container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "300px",
                    height: "250px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Webcam
                    className="annadanamcapture"
                    width={300}
                    height={250}
                    ref={webcamRef}
                  />
                </div>
              </div>{" "}
            </>
          </Col>
        </Row>
        <Divider />
        <Row gutter={(20, 20)} style={{ justifyContent: "center" }}></Row>
        <Row>
          <Modal
            visible={isModalVisible}
            width={450}
            footer={null}
            closable={false}
            centered
            maskClosable={false}
          >
            <TmsPrintTicket
              data={array}
              setData={setArray}
              type="Bhavani Deeksha"
              from="Counter"
              externalPrint={externalPrint}
              setExternalPrint={setExternalPrint}
              setButtonLoading={setButtonLoading}
              setPrintTicketModal={setIsModalVisible}
              ticketType={ticketType}
            />
          </Modal>
        </Row>
      </Card>
    </div>
  );
};

export default withRouter(PosShivaDeeksha);
